import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ContactUs = () => {
  const navigate = useNavigate();
  const [footerAddress, setFooterAddress] = useState([]);
  const [footerSocial, setFooterSocial] = useState([]);

  useEffect(() => {
    fetch(`https://marchtwo202501-5801b8caeb3a.herokuapp.com/footer-social`)
      .then((res) => res.json())
      .then((info) => setFooterSocial(info));
  }, []);

  useEffect(() => {
    fetch(`https://marchtwo202501-5801b8caeb3a.herokuapp.com/footer-address`)
      .then((res) => res.json())
      .then((info) => setFooterAddress(info));
  }, []);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    number: '',
    subject: '',
    message: '',
    messageStatus: 'UnRead',
  });

  const handleChange = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  const handleMessage = (event) => {
    event.preventDefault();

    fetch(`https://marchtwo202501-5801b8caeb3a.herokuapp.com/add-message`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then((result) => {
        alert('Message sent successfully');
        navigate('/thanks');
      })
      .catch((error) => {
        console.error('Error:', error);
        alert('Failed to send message. Please try again.');
      });
  };

  return (
    <section id="contact-sec" className=" mb-5 mt-5 ">
      <div className="container">
        {/* SECTION TITLE */}
        <div className="row">
          <div className="col-lg-10 offset-lg-1">
            <div className="section-title  text-center">
              <h1 className='one-head mt-5 mb-5' >Have Questions or Need Help?</h1>
            </div>
          </div>
        </div>

        {/* CONTACT FORM */}
        <div className="row">
          <div className="col-md-10 col-xl-8 offset-md-1 offset-xl-2">
            <div className="form-wrapper">
              <form onSubmit={handleMessage} className="row paragraph dark fs-1">
                
                {/* Name Input */}
                <div className="col-lg-6 mt-3">
                  <input 
                    type="text" 
                    name="name" 
                    className="form-control fs-1" 
                    placeholder="Your Name*" 
                    value={formData.name} 
                    onChange={handleChange} 
                    required 
                  />
                </div>

                {/* Email Input */}
                <div className="col-lg-6 mt-3">
                  <input 
                    type="email" 
                    name="email" 
                    className="form-control fs-1" 
                    placeholder="Email Address*" 
                    value={formData.email} 
                    onChange={handleChange} 
                    required 
                  />
                </div>

                {/* Phone Input */}
                <div className="col-md-12 mt-3">
                  <input 
                    type="text" 
                    name="number" 
                    className="form-control fs-1" 
                    placeholder="Phone" 
                    value={formData.number} 
                    onChange={handleChange} 
                  />
                </div>

                {/* Subject Input */}
                <div className="col-md-12 mt-3">
                  <input 
                    type="text" 
                    name="subject" 
                    className="form-control fs-1" 
                    placeholder="Your Subject" 
                    value={formData.subject} 
                    onChange={handleChange} 
                    required 
                  />
                </div>

                {/* Hidden Message Status */}
                <input type="hidden" name="messageStatus" value="UnRead" />

                {/* Message Textarea */}
                <div className="col-md-12 mt-3">
                  <textarea 
                    name="message" 
                    className="form-control fs-1 message" 
                    rows="5" 
                    placeholder="Your Message ..." 
                    value={formData.message} 
                    onChange={handleChange} 
                    required 
                  />
                </div>

                {/* Submit Button */}
                <div className="col-md-12 mt-5 text-right">
                  <button type="submit" className="button ">
                    Send Message
                  </button>
                </div>

              </form>
            </div>
          </div>
        </div>
      </div> 
    </section>
  );
};

export default ContactUs;
